import { safeParse } from 'shouldve-been-js';

class StatusDate {

    private _fieldName: string;
    private _visible: boolean;

    public constructor(fieldName: string, visible: boolean) {

        this._fieldName = fieldName;
        this._visible = visible;
    }

    public get fieldName(): string {
        return this._fieldName;
    }

    public set fieldName(value: string) {
        this._fieldName = value;
    }

    public get visible(): boolean {
        return this._visible;
    }

    public set visible(value: boolean) {
        this._visible = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): StatusDate {

        const fieldName: string = safeParse<string>(json?.FieldName, '');
        const visible: boolean = safeParse<boolean>(json?.Visible, false);

        return new StatusDate(fieldName, visible);
    }
}

export default StatusDate;